/**
 * @expFlag public-app-download-banner
 * @ticket CLOUDWEB-20131
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import browser from 'Cloud/browser';
import { IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import type { TemplateVariantString } from 'reactApp/appHelpers/featuresHelpers/types';

export type PublicAppDownloadBannerTouchType = {
    type: 'a' | 'b' | 'c' | 'd';
    href: string;
};

export const publicAppDownloadBannerTouch: false | PublicAppDownloadBannerTouchType =
    !browser.isSafari() && !browser.isMobileSafari() && !IS_WEBVIEW && IS_MOBILE_BROWSER && getFeature('public-app-download-banner');

export const abPublicAppDownloadBannerTouchSelector = (): TemplateVariantString | boolean => {
    if (publicAppDownloadBannerTouch && publicAppDownloadBannerTouch.type === 'a') {
        return 'variant1';
    }

    if (publicAppDownloadBannerTouch && publicAppDownloadBannerTouch.type === 'b') {
        return 'variant2';
    }

    if (publicAppDownloadBannerTouch && publicAppDownloadBannerTouch.type === 'c') {
        return 'variant3';
    }

    return false;
};
